import { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import { register as restRegister } from '../api/Rest/users';
import { RegisterResult, RegisterRespond } from '../models/SessionStore';
import { useSessionStore } from '../stores/SessionStore';
import { FirstParameter } from '../models/Utils';

const { register } = useSessionStore.getState();

const useRegister = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const registerAcc = useCallback(
    async (
      body: FirstParameter<typeof restRegister>,
      setErrorMessage?: (text: string) => void,
    ) => {
      const response: RegisterRespond = await register(body);
      const successPath = location.pathname.includes('wea-member')
        ? '/wea-member/register/success'
        : '/register/success';

      switch (response.result) {
        case RegisterResult.Success:
          navigate(successPath);
          break;
        case RegisterResult.EmailRegistered:
          setErrorMessage?.('This email has been registered.');
          break;
        case RegisterResult.ValidationError:
          setErrorMessage?.('Validation error.');
          break;
        case RegisterResult.Error:
        default:
          setErrorMessage?.('error');
          break;
      }
    },
    [navigate, location],
  );

  return { registerAcc };
};

export default useRegister;
